import { configureStore, combineReducers } from "@reduxjs/toolkit";
import fileCleanupMiddleware from "./middleware/fileCleanupMiddleware";

import { authSlice } from "./auth";
import { selectFormSlice } from "./select_form";
import { secretarySlice } from "./secretary";

// Paciente
import { patientSlice } from "./patient/patientSlice";
import { patientSurgerySlice as patientSurgeryPatientSlice } from "./patient/patientSurgerySlice";
import { formEventSlice as formEventPatientSlice } from "./patient/formEventSlice";
import { scheduleEventSlice as scheduleEventPatientSlice } from "./patient/scheduleEventSlice";
import { selectOptionsSlice as selectOptionsPatientSlice } from "./patient/selectOptionsSlice";
import { scheduleSlice } from "./patient/scheduleSlice";
import { viewMediaSlice } from "./patient/viewMediaSlice";
import { quizSlice } from "./patient/quizSlice";

// Admin
import { dashboardSlice } from "./dashboard";
import { patientsSlice } from "./secretary/patients";
import { doctorsSlice } from "./secretary/doctors";
import { procedureRoomsSlice } from "./secretary/procedure_rooms";
import { calendarSlice } from "./secretary/calendar";
import { adminSlice } from "./secretary/admin";
import { workShiftSlice } from "./secretary/work_shift";
import { shiftProcedureSlice } from "./secretary/shift_procedure";
import { summaryProcedureSlice } from "./secretary/summary_procedure";
import { patientSurgerySlice } from "./secretary/patient_surgery";
import { chartSlice as chartAdminSlice } from "./admin/chartSlice";
import { selectOptionsSlice as selectOptionsAdminSlice } from "./admin/selectOptionsSlice";

// Doctor
import { patientSurgerySlice as patientSurgeryDoctorSlice } from "./doctor/patientSurgerySlice";
import { dailyAssessmentSlice } from "./doctor/dailyAssessmentSlice";
import { scheduleEventSlice } from "./doctor/scheduleEventSlice";
import { formEventSlice } from "./doctor/formEventSlice";
import { selectOptionsSlice } from "./doctor/selectOptionsSlice";
import { sidebarSlice } from "./doctor/sidebarSlice";

// Go Safe
import { chatBotSlice } from "./gosafe/chatBotSlice";

const doctor = combineReducers({
  patientSurgery: patientSurgeryDoctorSlice.reducer,
  dailyAssessment: dailyAssessmentSlice.reducer,
  scheduleEvent: scheduleEventSlice.reducer,
  formEvent: formEventSlice.reducer,
  selectOptions: selectOptionsSlice.reducer,
  sidebar: sidebarSlice.reducer,
});

const patient = combineReducers({
  patientSurgery: patientSurgeryPatientSlice.reducer,
  patient: patientSlice.reducer,
  formEvent: formEventPatientSlice.reducer,
  scheduleEvent: scheduleEventPatientSlice.reducer,
  selectOptions: selectOptionsPatientSlice.reducer,
  schedule: scheduleSlice.reducer,
  viewMedia: viewMediaSlice.reducer,
  quiz: quizSlice.reducer,
});

const gosafe = combineReducers({
  chatBot: chatBotSlice.reducer,
});

const admin = combineReducers({
  chart: chartAdminSlice.reducer,
  selectOptions: selectOptionsAdminSlice.reducer,
});

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    selectForm: selectFormSlice.reducer,
    secretary: secretarySlice.reducer,
    patient,
    dashboard: dashboardSlice.reducer,
    patients: patientsSlice.reducer,
    doctors: doctorsSlice.reducer,
    procedureRooms: procedureRoomsSlice.reducer,
    calendar: calendarSlice.reducer,
    admin,
    workShift: workShiftSlice.reducer,
    shiftProcedure: shiftProcedureSlice.reducer,
    summaryProcedure: summaryProcedureSlice.reducer,
    patientSurgery: patientSurgerySlice.reducer,
    doctor,
    gosafe,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(fileCleanupMiddleware),
});
